if (typeof dataLayer === 'object') {
  dataLayer.push({
    event: 'shelfPage',
  });
}
